import { IconsEnum } from '../../../../../assets/icons/types';
import { ClassName, I18nText } from '../../../../../types';
import {
  OperationClientID,
  FetchOperationsCacheKey
} from '../../../operationsTypes';

import { useToastNotification } from '../../../../../common/hooks/useToastNotification';
import { useLeaveOfAbsenceForm } from '../../forms/LeaveOfAbsenceForm/hooks/useLeaveOfAbsenceForm';

import { LeaveOfAbsenceForm } from '../../forms/LeaveOfAbsenceForm';

import { AlertMessage } from '../../../../../helpers/AlertMessage';
import { FormModalButton } from '../../../../../helpers/buttons/FormModalButton';

import { operationsKeys, words } from '../../../../../locales/keys';

const LEAVE_OF_ABSENCE_FORM = 'leave-of-absence-form';
const LEAVE_OF_ABSENCE_BUTTON = 'leave-of-absence-button';

interface LeaveOfAbsenceModalButtonProps {
  clientId: OperationClientID;
  cacheKeys?: FetchOperationsCacheKey[];
  className?: ClassName;
  i18nText?: I18nText;
  i18nTextClassName?: ClassName;
  icon?: IconsEnum;
  iconClassName?: ClassName;
  withToastOnSuccess?: boolean;
  disabled?: boolean;
}

function LeaveOfAbsenceModalButton({
  clientId,
  cacheKeys,
  className,
  i18nText,
  i18nTextClassName,
  icon,
  iconClassName,
  withToastOnSuccess,
  disabled
}: LeaveOfAbsenceModalButtonProps) {
  const { showToastI18nNotification } = useToastNotification({
    appearance: 'success',
    i18nMessage: operationsKeys.recordAdded
  });

  const {
    validationErrors,
    registerFields,
    handleLeaveOfAbsence,
    resetLeaveOfAbsenceForm,
    createOperationReset,
    createOperationLoading,
    createOperationErrorMessage,
    control
  } = useLeaveOfAbsenceForm({
    cacheKeys,
    clientId,
    onSuccess: withToastOnSuccess ? showToastI18nNotification : undefined
  });

  return (
    <FormModalButton
      className={className}
      form={LEAVE_OF_ABSENCE_FORM}
      dataGa={LEAVE_OF_ABSENCE_BUTTON}
      i18nTitle={operationsKeys.leaveOfAbsence}
      i18nText={i18nText || words.create}
      i18nTextClassName={i18nTextClassName}
      i18nSubmitText={operationsKeys.addRecord}
      icon={icon}
      iconClassName={iconClassName}
      onOpen={resetLeaveOfAbsenceForm}
      isLoading={createOperationLoading}
      onClose={createOperationReset}
      onSubmit={handleLeaveOfAbsence}
      disabled={disabled}
    >
      <LeaveOfAbsenceForm
        form={LEAVE_OF_ABSENCE_FORM}
        isLoading={createOperationLoading}
        control={control}
        registerSubject={registerFields.registerSubject}
        subjectValidationError={validationErrors.subjectValidationError}
        bodyValidationError={validationErrors.bodyValidationError}
        dateValidationError={validationErrors.dateValidationError}
        completeDatetimeValidationError={
          validationErrors.completeDatetimeValidationError
        }
      />

      <div className="px-4">
        <AlertMessage message={createOperationErrorMessage} />
      </div>
    </FormModalButton>
  );
}

export default LeaveOfAbsenceModalButton;
